import { render } from "./ProduceRoadbooks.vue?vue&type=template&id=965dd838"
import script from "./ProduceRoadbooks.vue?vue&type=script&lang=js"
export * from "./ProduceRoadbooks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__